import { render, staticRenderFns } from "./View_UOM.vue?vue&type=template&id=273a77c6&scoped=true"
import script from "./View_UOM.vue?vue&type=script&lang=js"
export * from "./View_UOM.vue?vue&type=script&lang=js"
import style0 from "./View_UOM.vue?vue&type=style&index=0&id=273a77c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a77c6",
  null
  
)

export default component.exports